import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { MagentoCustomer } from '../../models';
import { TmsWebBaseService } from '../base';

@Injectable({
  providedIn: 'root',
})
export class CustomerMagentoService extends TmsWebBaseService {
  constructor() {
    super('CustomerMagento');
  }

  getCustomer(id: number): Observable<MagentoCustomer> {
    return this.httpService.get<MagentoCustomer>(`${this.apiUrl}/GetCustomer/${id}`);
  }

  getCustomers(): Observable<MagentoCustomer[]> {
    return this.httpService.get<MagentoCustomer[]>(`${this.apiUrl}/GetCustomers`);
  }
}
